<mat-form-field appearance="outline">
  <mat-label>Двигатель</mat-label>
  <mat-chip-list #chipList>
    <mat-chip
      *ngFor="let engine of selectedEngines"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(engine.id)"
    >
      {{ engine.description }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="Новое значение..."
      [formControl]="engineCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event)">
    <mat-option *ngFor="let engine of filteredEngines" [value]="engine">
      <div class="engine_wrapper">
        <span class="engine_description">{{ engine.description }}</span>
        <span class="manufacturer_description">{{ engine.manufacturer?.description }}</span>
      </div>
    </mat-option>
    <mat-option *ngIf="filteredEngines.length === 0" [value]="engineCtrl.value">
      Создать {{ engineCtrl.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
